import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import styles from "./HeroSection.module.css";

const slides = [
  {
    image: "/images/slide1.jpg",
    titleLine1: "Aurelia, where every moment",
    titleLine2: "is pure refinement.",
  },
  {
    image: "/images/slide2.jpg",
    titleLine1: "Crafted for those who appreciate",
    titleLine2: "the finer things.",
  },
  {
    image: "/images/slide3.jpg",
    titleLine1: "Timeless sophistication,",
    titleLine2: "designed just for you.",
  },
];

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className={styles.container}>
      {slides.map((slide, index) => (
        <div
          key={index}
          className={styles.background}
          style={{
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${slide.image})`,
            opacity: index === currentSlide ? 1 : 0,
            zIndex: index === currentSlide ? 1 : 0,
          }}
        />
      ))}

      <div className={styles.overlay}>
        <h1 className={styles.title}>
          {slides[currentSlide].titleLine1}
          <br />
          {slides[currentSlide].titleLine2}
        </h1>
        <div className={styles.buttonGroup}>
           <Link to="/residencies" className={styles.button}>
            Book Now
          </Link>
          <a href="tel:+2348165028212" className={styles.link}>
            <button className={`${styles.button} ${styles.callButton}`}>Call to Book</button>
          </a>
        </div>
        <p className={styles.subtitle}>A Golden Experience</p>
      </div>
    </section>
  );
};

export default Hero;
